"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccessoryCalculatedPriceByCustomerType = exports.getPriceByCustomerType = exports.getPriceFieldNameByCustomerType = exports.getOrderPrices = exports.getPriceForCalculation = exports.getCalculationByType = exports.getCalculationPriceByType = void 0;
const enums_1 = require("../../enums");
const getCalculationPriceByType = (order, financingType) => {
    var _a;
    const calculation = (0, exports.getCalculationByType)(order, financingType);
    const isBusiness = ((_a = order === null || order === void 0 ? void 0 : order.customer) === null || _a === void 0 ? void 0 : _a.customerType) === enums_1.CustomerType.BUSINESS;
    return calculation ? (0, exports.getPriceForCalculation)(calculation, financingType, isBusiness) : null;
};
exports.getCalculationPriceByType = getCalculationPriceByType;
const getCalculationByType = (order, financingType) => {
    const calculation = (order === null || order === void 0 ? void 0 : order.offers) ? order.offers.find((offer) => offer.financingType === financingType) : null;
    return calculation || null;
};
exports.getCalculationByType = getCalculationByType;
const getPriceForCalculation = (calculation, financingType, isBusiness = false) => {
    const field = financingType === enums_1.FinancingType.CASH ? 'totalCost' : 'totalMonthlyCost';
    return calculation.financing && calculation.financing.hasOwnProperty(field) ? calculation.financing[field] : null;
};
exports.getPriceForCalculation = getPriceForCalculation;
const getOrderPrices = (order) => {
    return {
        cash: (0, exports.getCalculationPriceByType)(order, enums_1.FinancingType.CASH),
        loan: (0, exports.getCalculationPriceByType)(order, enums_1.FinancingType.LOAN),
        leasing: (0, exports.getCalculationPriceByType)(order, enums_1.FinancingType.LEASING),
    };
};
exports.getOrderPrices = getOrderPrices;
const getPriceFieldNameByCustomerType = (customerType, suffix = 'price') => customerType === enums_1.CustomerType.BUSINESS ? `${suffix}ExcludingVat` : suffix;
exports.getPriceFieldNameByCustomerType = getPriceFieldNameByCustomerType;
const getPriceByCustomerType = (object, customerType = null, suffix = 'price') => {
    if (!object || customerType === null)
        return 0;
    const fieldName = (0, exports.getPriceFieldNameByCustomerType)(customerType, suffix);
    const hasPrice = object.hasOwnProperty(fieldName) && typeof object[fieldName] === 'number';
    if (!hasPrice)
        return 0;
    return object[fieldName];
};
exports.getPriceByCustomerType = getPriceByCustomerType;
const getAccessoryCalculatedPriceByCustomerType = (object, customerType = null) => {
    if (!object || customerType === null)
        return 0;
    const fieldName = customerType === enums_1.CustomerType.BUSINESS ? 'calculatedPriceBusiness' : 'calculatedPricePrivate';
    const hasPrice = object.hasOwnProperty(fieldName) && typeof object[fieldName] === 'number';
    if (!hasPrice)
        return 0;
    return object[fieldName];
};
exports.getAccessoryCalculatedPriceByCustomerType = getAccessoryCalculatedPriceByCustomerType;
//# sourceMappingURL=financing.js.map